import React from 'react';
import PropTypes from 'prop-types';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import { mapState } from '@deerplusofficial/pos-helper';
import { Button as ButtonBase } from '@deerplusofficial/pos-components';
import styled from 'styled-components';
import { withMutatePreOrder, withPrintPreOrder } from '../../model/Mutations';

const Container = styled.div`
  display: flex;
`;

const Button = styled(ButtonBase).attrs({ tall: true })`
  border-radius: 0;
  width: 50%;
`;

class CartPreOrderDetailFooter extends React.PureComponent {
  static propTypes = {
    preOrder: PropTypes.shape(),
  };

  static defaultProps = {
    preOrder: {},
  };

  get isSavable() {
    const {
      preOrder: { isSaved, name, description },
    } = this.props;

    return Boolean((name || description) && !isSaved);
  }

  render() {
    const { preOrder, isPreOrderMutating, isPreOrderPrinting, onPreOrderMutate, onPreOrderPrint } = this.props;

    return (
      <Container>
        <Button primary loading={isPreOrderPrinting} disabled={!preOrder.isSaved} onClick={onPreOrderPrint}>
          列印明細
        </Button>
        <Button
          info
          loading={isPreOrderMutating}
          disabled={!this.isSavable}
          onClick={onPreOrderMutate}
        >
          儲存
        </Button>
      </Container>
    );
  }
}

export default fp.compose(
  withMutatePreOrder(),
  withPrintPreOrder(),
  connect(mapState(['preOrder']))
)(CartPreOrderDetailFooter);



// WEBPACK FOOTER //
// ./src/components/Cart/CartPreOrderDetailFooter.js